import { toParamString, getQueryParams } from "../utils/UrlUtility";
import { doFetch } from "./apiFetchHelper";

export const fetchFavoritesNearby = (location) => {
  const { lat, lon } = location;
  const url = `/api/search?lat=${lat}&lon=${lon}&per_page=40&sort=distance&distance=10mi&online=none`;

  return doFetch(url);
};

export const fetchPopularBrands = (location) => {
  const { lat, lon } = location;
  const url = `/api/search?per_page=40&sort=uses&online=include&lat=${lat}&lon=${lon}`;

  return doFetch(url);
};

export const fetchHotDeals = () => {
  const url = `/api/search?phrase=HotDeal`;

  return doFetch(url);
};

export const fetchOurPickEatPlayShop = () => {
  const url = `/api/search?phrase=ourpick`;

  return doFetch(url);
};

export const fetchOurPickThemePark = () => {
  const url = `/api/search?phrase=themeparkpick`;

  return doFetch(url);
};

export const fetchCampaignData = (channel, params = {}) => {
  if (!channel) {
    throw new Error("Campaign channel key is required");
  }
  const paramsString = toParamString(params);
  const campaignDataUrl = `/api/campaigns/${channel}${
    paramsString !== "" ? "?" + paramsString : ""
  }`;
  return doFetch(campaignDataUrl);
};

export const fetchFeaturedDeals = (params) => {
  return fetchCampaignData("featured_deals", params);
};

export const fetchBannerDeals = (params) => {
  return fetchCampaignData("main_page_banner", params);
};

export const fetchRecommendations = () => {
  const params = getQueryParams();
  const mockId = params.mock_member_id;
  const forwardedIdParam = mockId ? `/?mock_member_id=${mockId}` : "";
  const url = `/api/recommendations${forwardedIdParam}`;
  return doFetch(url);
};

export const fetchTopOnlineDeals = (params) => {
  const paramsString = toParamString(params);
  const topOnlineDealsUrl = `/api/campaigns/top_brands${
    paramsString !== "" ? "?" + paramsString : ""
  }`;

  return doFetch(topOnlineDealsUrl);
};
